'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhoneBluetoothSpeaker = function MdPhoneBluetoothSpeaker(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 25.9q0.7 0 1.1 0.4t0.5 1.2v5.9q0 0.7-0.5 1.1t-1.1 0.5q-11.8 0-20.1-8.3t-8.3-20.1q0-0.7 0.5-1.1t1.1-0.5h5.9q0.7 0 1.2 0.5t0.4 1.1q0 3.2 1 6 0.3 1-0.4 1.7l-3.7 3.7q3.7 7.2 11 11l3.7-3.7q0.7-0.7 1.7-0.4 2.8 1 6 1z m-3.4-13.9v3.2l1.6-1.6z m0-7.2v3.2l1.6-1.6z m-5.5 11.1l-1.1-1.2 4.6-4.7-4.6-4.7 1.1-1.2 3.9 3.9v-6.4h0.7l4.8 4.8-3.6 3.6 3.6 3.6-4.8 4.8h-0.7v-6.4z' })
        )
    );
};

exports.default = MdPhoneBluetoothSpeaker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phone-bluetooth-speaker.js
// module id = 3185
// module chunks = 0